import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class contabilidadPolizasexternasAlgodonerosIngresosLista {
  registrosVinculados = [] //aquí están todos los registros vinculados (Se eliminarán antes de hacer cualquier operación)
  movimientosVinculados = [] // movimientos vinculados
  movNoRelacionados = 0;
  regisNoRelacionados = 0;
  regTotal = 0;
  porceVincu = 0;

  constructor(PolizasExternasAlgodonerosIngresos, $filter, $file) {
    this.PolizasExternasAlgodonerosIngresos = PolizasExternasAlgodonerosIngresos
    this.verificarCadena = $filter('rPad')
    this.$file = $file
    this.$filter = $filter
  }

  $onInit() {
    this.promise = this.PolizasExternasAlgodonerosIngresos.get(this.busqueda)
      .then((resolve) => { this.data = resolve.data })
  }

  cerrarVinculacion(movimiento) {
    if (movimiento) {
      const item = this.movimientosBancarios.find((i) => this.movimientoVinculacion.id === i.id)
      item.relacionado = true
    }

    this.movimientoVinculacion = null
    this.data = [].concat(this.data)
  }

  eliminarVinculacion() { }
}

module.component('contabilidadPolizasexternasAlgodonerosIngresosLista', {
  controller: contabilidadPolizasexternasAlgodonerosIngresosLista,
  template,
  bindings: {
    busqueda: '<',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/ingresos/lista/component.js